import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-common-update-permission-modal',
  templateUrl: './common-update-permission-modal.component.html',
  styleUrls: ['./common-update-permission-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonUpdatePermissionModalComponent {

}
